import {
  SkillsCheckAttempt,
  SkillsCheckPanel,
} from "src/app/_models/SkillsCheck";

export interface SkillsCheckState {
  state: any;
  course: number;
  result: SkillsCheckPanel[];
  resultError: any;
  loading: boolean;
  error: any;
  enable: boolean | null;
  selectedSkillsCheckPanel: SkillsCheckPanel;
  selectedSkillsCheckAttempts: SkillsCheckAttempt[];
  selectedAttempt: SkillsCheckAttempt;
}

export const initialSkillsCheckState: SkillsCheckState = {
  state: null,
  course: 0,
  result: [],
  resultError: null,
  error: null,
  loading: false,
  enable: null,
  selectedSkillsCheckPanel: null,
  selectedSkillsCheckAttempts: [],
  selectedAttempt: null,
};
